/* Grace & Cary — small custom behaviour on top of Dawn (tabs, sticky ATC). */
(function () {
  /* Tabs (sections/gc-best-sellers.liquid) */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.gc-tabs__tab');
    if (!tab) return;
    var root = tab.closest('.gc-tabs');
    root.querySelectorAll('.gc-tabs__tab').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    window.dispatchEvent(new Event('resize')); /* let Dawn's slider-component re-measure */
  });

  /* Sticky add to cart (sections/gc-sticky-atc.liquid) */
  if (!customElements.get('gc-sticky-atc')) {
    customElements.define(
      'gc-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          this.mainButton = document.querySelector('product-info .product-form__submit, .product__info-container .product-form__submit');
          if (!this.mainButton) return;
          this.hidden = false;
          this.querySelector('[data-gc-sticky-button]').addEventListener('click', () => this.mainButton.click());
          var io = new IntersectionObserver((entries) => {
            var entry = entries[0];
            var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', past);
            if (past) this.syncPrice();
          });
          io.observe(this.mainButton);
        }
        syncPrice() {
          var price = document.querySelector('product-info .price__container, .product__info-container .price__container');
          var target = this.querySelector('[data-gc-sticky-price]');
          if (!price || !target) return;
          var sale = price.querySelector('.price__sale .price-item--sale');
          var regular = price.querySelector('.price__regular .price-item--regular');
          var wrap = price.closest('.price');
          var text = wrap && wrap.classList.contains('price--on-sale') && sale ? sale.textContent : regular ? regular.textContent : '';
          if (text.trim()) target.textContent = text.trim();
          var vt = this.querySelector('[data-gc-sticky-variant]');
          if (vt) {
            var picked = Array.from(document.querySelectorAll('variant-selects fieldset input:checked, variant-selects select'))
              .map(function (el) { return el.value; }).filter(Boolean);
            if (picked.length) vt.textContent = picked.join(' / ');
          }
          var disabled = this.mainButton.hasAttribute('disabled');
          this.querySelector('[data-gc-sticky-button]').toggleAttribute('disabled', disabled);
        }
      }
    );
  }

  /* Cart drawer: "You may also like" (sections/gc-cart-recs.liquid) */
  if (!customElements.get('gc-cart-recs')) {
    customElements.define('gc-cart-recs', class extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url || this.dataset.loaded) return;
        this.dataset.loaded = '1';
        fetch(url).then(function (r) { return r.text(); }).then((html) => {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = doc.querySelector('.gc-recs');
          var skip = this.dataset.exclude; /* PDP: never suggest the product being viewed */
          if (box && skip) box.querySelectorAll('.gc-recs__item[data-product-id="' + skip + '"]').forEach(function (li) { li.remove(); });
          if (box && box.querySelector('.gc-recs__item')) this.innerHTML = box.outerHTML;
        }).catch(function () {});
      }
    });
  }

  /* Cart drawer: discount code field (applies the code to the cart; Shopify checks it) */
  if (!customElements.get('gc-cart-discount')) {
    customElements.define('gc-cart-discount', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.gc-discount__input');
        this.msg = this.querySelector('.gc-discount__msg');
        this.querySelector('.gc-discount__apply').addEventListener('click', () => this.apply());
        this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.apply(); } });
      }
      apply() {
        var code = (this.input.value || '').trim();
        if (!code) return;
        this.msg.textContent = '';
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }) })
          .then(function (r) { return r.json(); })
          .then((cart) => {
            var hit = (cart.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
            if (hit && hit.applicable) {
              return fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
                var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
                var fresh = doc.querySelector('#CartDrawer');
                var cur = document.querySelector('#CartDrawer');
                if (fresh && cur) cur.innerHTML = fresh.innerHTML;
              });
            }
            this.msg.textContent = 'This code is not valid for your cart.';
          })
          .catch(() => { this.msg.textContent = 'Something went wrong. You can also enter the code at checkout.'; });
      }
    });
  }

  /* Cart drawer: "+ Add" on a recommendation opens a slim product panel (sections/gc-quick-add.liquid) on top of the
     drawer; the shopper picks colour/size and adds without leaving the cart. */
  var qa = {
    open: function (url) {
      var panel = document.getElementById('GcQuickAdd');
      if (!panel) {
        panel = document.createElement('div');
        panel.id = 'GcQuickAdd'; panel.className = 'gc-qa-panel'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
        panel.innerHTML = '<div class="gc-qa-panel__head"><span>Select options</span><button type="button" class="gc-qa-panel__close" aria-label="Close">&times;</button></div><div class="gc-qa-panel__content"></div>';
        document.body.appendChild(panel);
        panel.querySelector('.gc-qa-panel__close').addEventListener('click', qa.close);
      }
      var content = panel.querySelector('.gc-qa-panel__content');
      content.innerHTML = '<p class="gc-qa__loading">Loading…</p>';
      panel.classList.add('is-open');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=gc-quick-add').then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('.gc-qa');
        if (!box) { window.location.href = url; return; }
        content.innerHTML = '';
        content.appendChild(box);
        qa.bind(box);
      }).catch(function () { window.location.href = url; });
    },
    close: function () { var p = document.getElementById('GcQuickAdd'); if (p) p.classList.remove('is-open'); },
    bind: function (box) {
      var variants = JSON.parse(box.querySelector('[data-gc-qa-variants]').textContent);
      var sets = Array.prototype.slice.call(box.querySelectorAll('.gc-qa__opt'));
      var picked = sets.map(function () { return null; });
      var add = box.querySelector('[data-gc-qa-add]'), msg = box.querySelector('[data-gc-qa-msg]');
      /* one value only → preselect it */
      sets.forEach(function (fs, i) { var vals = fs.querySelectorAll('.gc-qa__val'); if (vals.length === 1) picked[i] = vals[0].dataset.value; });
      function match() { return variants.find(function (v) { return v.options.every(function (o, i) { return picked[i] === o; }); }); }
      function render() {
        sets.forEach(function (fs, i) {
          fs.querySelector('[data-gc-qa-picked]').textContent = picked[i] || '';
          fs.querySelectorAll('.gc-qa__val').forEach(function (b) {
            b.setAttribute('aria-pressed', b.dataset.value === picked[i] ? 'true' : 'false');
            var probe = picked.slice(); probe[i] = b.dataset.value;
            var ok = variants.some(function (v) { return v.available && v.options.every(function (o, k) { return probe[k] === null || probe[k] === o; }); });
            b.classList.toggle('is-unavailable', !ok);
          });
        });
        var v = sets.length ? match() : variants[0];
        if (v) {
          box.querySelector('[data-gc-qa-price]').textContent = v.price;
          if (v.image) { var first = box.querySelector('.gc-qa__media img'); if (first) { first.src = v.image; box.querySelector('.gc-qa__media').scrollLeft = 0; } }
        }
        add.disabled = !(v && v.available);
        add.textContent = v ? (v.available ? 'Add to cart' : 'Sold out') : 'Select ' + sets.filter(function (fs, i) { return !picked[i]; }).map(function (fs) { return fs.querySelector('legend').firstChild.textContent.replace(':', '').trim().toLowerCase(); }).join(' & ');
      }
      sets.forEach(function (fs, i) {
        fs.addEventListener('click', function (e) { var b = e.target.closest('.gc-qa__val'); if (!b) return; picked[i] = b.dataset.value; msg.textContent = ''; render(); });
      });
      add.addEventListener('click', function () {
        var v = sets.length ? match() : variants[0];
        if (!v) return;
        add.disabled = true; add.classList.add('loading');
        var drawer = document.querySelector('cart-drawer');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            add.classList.remove('loading');
            if (res.status) { msg.textContent = res.description || 'Could not add this item.'; add.disabled = false; return; }
            qa.close();
            if (drawer) drawer.classList.remove('is-empty');
            if (drawer && drawer.renderContents) { res.id = v.id; drawer.renderContents(res); }
            else window.location.href = '/cart';
          })
          .catch(function () { add.classList.remove('loading'); add.disabled = false; msg.textContent = 'Something went wrong. Please try again.'; });
      });
      render();
    }
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gc-quick-add]');
    if (!b) return;
    e.preventDefault();
    qa.open(b.dataset.gcQuickAdd);
  });
  document.addEventListener('keydown', function (e) {
    var p = document.getElementById('GcQuickAdd');
    if (e.key === 'Escape' && p && p.classList.contains('is-open')) { e.stopPropagation(); qa.close(); }
  }, true);
})();

/* GC 2026-10-11 Shop the Look: <gc-look> item lists (homepage panel, look page, PDP "Complete the Look"), the look panel
   (bottom sheet on mobile, side panel on desktop) and Women/Men/occasion filter chips. Options come from /products/<handle>.js;
   the styled variant's colour etc. is preselected, size is left to the shopper unless there is only one. */
(function () {
  function money(cents) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2); }
  function addToCart(items, btn, msg, done) {
    var drawer = document.querySelector('cart-drawer');
    btn.disabled = true; btn.classList.add('loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('loading'); btn.disabled = false;
        if (res.status) { msg.textContent = res.description || 'Could not add this item.'; return; }
        if (done) done();
        /* like Dawn's product-form: a drawer rendered empty keeps .is-empty (hides the header, breaks the layout) */
        if (drawer) drawer.classList.remove('is-empty');
        if (drawer && drawer.renderContents) { res.id = items[0].id; drawer.renderContents(res); }
        else window.location.href = '/cart';
      })
      .catch(function () { btn.classList.remove('loading'); btn.disabled = false; msg.textContent = 'Something went wrong. Please try again.'; });
  }

  if (!customElements.get('gc-look')) customElements.define('gc-look', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      var self = this;
      this.items = Array.prototype.slice.call(this.querySelectorAll('.gc-look__item')).map(function (li) { return self.setup(li); });
      var all = this.querySelector('[data-gc-look-all]');
      if (all) all.addEventListener('click', function () {
        var msg = self.querySelector('[data-gc-look-allmsg]'), missing = [];
        var picks = self.items.map(function (it) { var v = it.match(); if (!v) missing.push(it); return v; });
        self.items.forEach(function (it) { it.li.classList.toggle('is-missing', missing.indexOf(it) > -1); });
        if (missing.length) { msg.textContent = 'Please select ' + (missing.length === 1 ? 'a size for item ' + missing[0].li.dataset.index : 'sizes for items ' + missing.map(function (m) { return m.li.dataset.index; }).join(', ')) + '.'; missing[0].li.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); return; }
        msg.textContent = '';
        addToCart(picks.map(function (v) { return { id: v.id, quantity: 1 }; }), all, msg, lookPanel.close);
      });
    }
    setup(li) {
      var box = li.querySelector('[data-gc-look-opts]'), add = li.querySelector('[data-gc-look-add]'), msg = li.querySelector('.gc-look__msg');
      var it = { li: li, product: null, picked: [], selects: [], match: function () { return null; } };
      fetch('/products/' + li.dataset.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        it.product = p;
        var styled = p.variants.find(function (v) { return String(v.id) === li.dataset.variant; }) || p.variants[0];
        it.match = function () { return p.variants.find(function (v) { return v.options.every(function (o, i) { return it.picked[i] === o; }); }) || null; };
        p.options.forEach(function (o, i) {
          var isSize = /size/i.test(o.name);
          it.picked[i] = (!isSize || o.values.length === 1) ? styled.options[i] : null;
          if (!isSize && o.values.length === 1) return;
          var s = document.createElement('select'); s.className = 'gc-look__select'; s.setAttribute('aria-label', o.name);
          if (it.picked[i] === null) s.innerHTML = '<option value="">' + o.name + '</option>';
          o.values.forEach(function (val) { var opt = document.createElement('option'); opt.value = val; opt.textContent = isSize ? val : o.name + ': ' + val; s.appendChild(opt); });
          s.value = it.picked[i] || '';
          s.addEventListener('change', function () { it.picked[i] = s.value || null; li.classList.remove('is-missing'); msg.textContent = ''; refresh(); });
          box.appendChild(s); it.selects[i] = s;
        });
        function refresh() {
          it.selects.forEach(function (s, i) {
            if (!s) return;
            Array.prototype.forEach.call(s.options, function (opt) {
              if (!opt.value) return;
              var probe = it.picked.slice(); probe[i] = opt.value;
              var ok = p.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return probe[k] === null || probe[k] === o; }); });
              opt.disabled = !ok; opt.textContent = opt.value.replace(/ — sold out$/, '') + (ok ? '' : ' — sold out');
              if (!/size/i.test(p.options[i].name)) opt.textContent = p.options[i].name + ': ' + opt.value + (ok ? '' : ' — sold out');
            });
          });
          var v = it.match();
          if (v) {
            li.querySelector('[data-gc-look-price]').textContent = money(v.price);
            if (v.featured_image) { var img = li.querySelector('.gc-look__img img'); if (img) img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=240'; }
          }
          add.disabled = !!(v && !v.available);
          add.textContent = v && !v.available ? 'Sold out' : 'Add';
        }
        refresh();
      }).catch(function () { add.addEventListener('click', function () { window.location.href = li.querySelector('a').href; }); });
      add.addEventListener('click', function () {
        if (!it.product) return;
        var v = it.match();
        if (!v) { li.classList.add('is-missing'); msg.textContent = 'Please select a size.'; return; }
        addToCart([{ id: v.id, quantity: 1 }], add, msg, lookPanel.close);
      });
      return it;
    }
  });

  var lookPanel = {
    open: function (handle) {
      var tpl = document.getElementById('GcLookTpl-' + handle);
      if (!tpl) return false;
      var panel = document.getElementById('GcLookPanel');
      if (!panel) {
        panel = document.createElement('div'); panel.id = 'GcLookPanel'; panel.className = 'gc-lookpanel';
        panel.innerHTML = '<div class="gc-lookpanel__overlay" data-gc-look-close></div><div class="gc-lookpanel__sheet" role="dialog" aria-modal="true" aria-label="Shop the look"><div class="gc-lookpanel__head"><span>Shop the Look</span><button type="button" class="gc-qa-panel__close" aria-label="Close" data-gc-look-close>&times;</button></div><div class="gc-lookpanel__content"></div></div>';
        document.body.appendChild(panel);
        panel.addEventListener('click', function (e) { if (e.target.closest('[data-gc-look-close]')) lookPanel.close(); });
      }
      var c = panel.querySelector('.gc-lookpanel__content'); c.innerHTML = ''; c.appendChild(tpl.content.cloneNode(true)); c.scrollTop = 0;
      panel.classList.add('is-open'); document.body.classList.add('gc-noscroll');
      return true;
    },
    close: function () { var p = document.getElementById('GcLookPanel'); if (p && p.classList.contains('is-open')) { p.classList.remove('is-open'); document.body.classList.remove('gc-noscroll'); } }
  };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-gc-look-open]');
    if (o && lookPanel.open(o.dataset.gcLookOpen)) { e.preventDefault(); return; }
    var d = e.target.closest('[data-gc-dot]');
    if (d) { var li = document.querySelector('.gc-lookpage .gc-look__item[data-index="' + d.dataset.gcDot + '"]'); if (li) { li.scrollIntoView({ block: 'center', behavior: 'smooth' }); li.classList.add('is-flash'); setTimeout(function () { li.classList.remove('is-flash'); }, 1200); } }
    var f = e.target.closest('[data-gc-filter]');
    if (f) {
      var wrap = f.closest('[data-gc-stl]'), val = f.dataset.gcFilter;
      wrap.querySelectorAll('[data-gc-filter]').forEach(function (b) { b.setAttribute('aria-selected', b === f ? 'true' : 'false'); });
      wrap.querySelectorAll('.gc-look-card').forEach(function (card) {
        card.hidden = !(val === 'all' || card.dataset.gender === val || card.dataset.occasion === val || card.dataset.gender === 'unisex');
      });
      var row = wrap.querySelector('.gc-stl__row'); if (row) row.scrollLeft = 0;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lookPanel.close(); });
  /* homepage tabs start on Women */
  document.querySelectorAll('.gc-stl [data-gc-filter][aria-selected="true"]').forEach(function (b) { b.click(); });
})();
